var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Card } from '../card';
import { Link } from '../link';
import { PageHeader } from '../page';
import { RowLayout } from '../row-layout';
import { styled } from '../styled';
import { Text } from '../text';
import { emptyStateClasses, emptyStateComponentName, getEmptyStateUtilityClass, } from './empty-state-classes';
import { useMergedClasses } from '../styles/classes';
import clsx from '../utils/clsx';
export var Root = styled(RowLayout, {
    name: emptyStateComponentName,
    slot: 'Root',
})({});
export var StyledCard = styled(Card, {
    name: emptyStateComponentName,
    slot: 'Card',
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
});
export var Subtitle = styled(Text, {
    name: emptyStateComponentName,
    slot: 'Subtitle',
})(function (_a) {
    var theme = _a.theme;
    return ({
        marginBottom: theme.spacing(1),
    });
});
export var Content = styled(RowLayout, {
    name: emptyStateComponentName,
    slot: 'Content',
})({
    maxWidth: 500,
    margin: '0 auto',
});
export var Actions = styled('div', {
    name: emptyStateComponentName,
    slot: 'Actions',
})(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& > :not(:last-child)': {
            marginRight: theme.spacing(2),
        },
    });
});
export var Icon = styled('div', {
    name: emptyStateComponentName,
    slot: 'Icon',
})(function (_a) {
    var theme = _a.theme;
    return ({
        marginBottom: theme.spacing(2),
        color: theme.tokens.color_fg_brand_primary_subtle,
        '& > svg': {
            fontSize: theme.typography.pxToRem(180),
            height: '1em',
            width: '1em',
        },
    });
});
export var Message = styled(Text)(function (_a) {
    var theme = _a.theme;
    return ({
        marginBottom: theme.spacing(1),
    });
});
export var EmptyState = React.forwardRef(function (props, ref) {
    var actions = props.actions, breadcrumbs = props.breadcrumbs, children = props.children, className = props.className, icon = props.icon, message = props.message, _a = props.PageHeaderProps, PageHeaderProps = _a === void 0 ? {} : _a, title = props.title, subtitle = props.subtitle, _b = props.messageTypographyProps, messageTypographyProps = _b === void 0 ? {} : _b, _c = props.titleTypographyProps, titleTypographyProps = _c === void 0 ? {} : _c, _d = props.subtitleTypographyProps, subtitleTypographyProps = _d === void 0 ? {} : _d, link = props.link, rootProps = __rest(props, ["actions", "breadcrumbs", "children", "className", "icon", "message", "PageHeaderProps", "title", "subtitle", "messageTypographyProps", "titleTypographyProps", "subtitleTypographyProps", "link"]);
    var classes = useMergedClasses(emptyStateClasses, getEmptyStateUtilityClass, props.classes);
    var linkProps = typeof link === 'string'
        ? {
            href: link,
            target: '_blank',
        }
        : link;
    return (React.createElement(Root, __assign({ ref: ref, className: clsx(classes.root, className), gutter: 5 }, rootProps),
        (!!title || !!PageHeaderProps.title) && (React.createElement(PageHeader, __assign({}, PageHeaderProps, { className: classes.pageHeader, title: title || PageHeaderProps.title, titleTypographyProps: titleTypographyProps, breadcrumbs: breadcrumbs }))),
        React.createElement(StyledCard, { size: "xlarge", className: classes.card },
            React.createElement(Icon, { className: classes.icon }, icon),
            !!subtitle && (React.createElement(Subtitle, __assign({ variant: "h4", className: classes.subtitle }, subtitleTypographyProps), subtitle)),
            React.createElement(Content, { className: classes.content, gutter: 2 },
                React.createElement(Message, __assign({ variant: "body2", color: "textSecondary", className: classes.message }, messageTypographyProps), message || children),
                !!actions && React.createElement(Actions, { className: classes.actions }, actions),
                !!linkProps && (React.createElement(Link, __assign({ className: classes.link, variant: "inherit" }, linkProps), linkProps.children || 'Learn More'))))));
});
